import { AUTH_URL } from "../constants"
import { AUTH_KEY } from "../context/authContext"
import { APIRequest, HTTPClient, RequestType } from "../services/http_client"
import LocalStorageService from "../services/localstorage.service"
import { PageType } from "../types/page";

const client = new HTTPClient();

export interface PageFilters {
    page?: number;
    limit?: number;
    title?: string;
    published?: number;
}

interface ResponseType {
    pages?: {
        data: Array<PageType>;
    };
    total?: number;
    error?: string;
}

interface CRUDResponse {
    success?: boolean;
    error?: string;
}

const encodeFilters = (filters: PageFilters) => {
    const encodedFilters = new URLSearchParams()
  
    Object.keys(filters).forEach((filter: any) => {
      const filterKey = filter as keyof PageFilters;
      if(filters[filterKey] !== undefined){
        encodedFilters.append(filter, filters[filterKey]?.toString() ?? '')
      }
    })
  
    return encodedFilters.toString()
  }

class PageModel {
    static async all(filters: PageFilters){
        const auth = LocalStorageService.get(AUTH_KEY)
      if(!auth) return {
        error: "Unauthorized"
      }

      const request = new APIRequest(
        RequestType.GET,
        `${AUTH_URL}/static-pages?${encodeFilters(filters)}`,
        undefined,
        auth.accessToken
      )

      const response = await client.get(request)

      if (!response.success) {
          return {
              error: response.errorMessage,
          }
      }

      return response.result as unknown as ResponseType
    }

    static async find(itemId: number){
        const auth = LocalStorageService.get(AUTH_KEY)
      if(!auth) return {
        error: "Unauthorized"
      }

      const request = new APIRequest(
        RequestType.GET,
        `${AUTH_URL}/static-pages/${itemId}`,
        undefined,
        auth.accessToken
      )

      const response = await client.get(request)

      if (!response.success) {
          return {
              error: response.errorMessage,
          }
      }

      return response.result as unknown as ResponseType
    }

    static async remove(itemId: number){
      const auth = LocalStorageService.get(AUTH_KEY)
      if(!auth) return {
        error: "Unauthorized"
      }

      const request = new APIRequest(
        RequestType.DELETE,
        `${AUTH_URL}/static-pages/${itemId}`,
        undefined,
        auth.accessToken
      )

      const response = await client.delete(request)

      if (!response.success) {
          return {
              error: response.errorMessage,
          }
      }

      return response.result as unknown as CRUDResponse
    }

    static async save(data: PageType){
        const auth = LocalStorageService.get(AUTH_KEY)
        if(!auth) return {
            error: "Unauthorized"
        }

        const request = new APIRequest(
            data.id ? RequestType.PUT : RequestType.POST,
            data.id ? `${AUTH_URL}/static-pages/${data.id}` : `${AUTH_URL}/static-pages`,
            JSON.stringify(data),
            auth.accessToken,
        );

        const response =  data.id ? await client.put(request) : await client.post(request);

        if (!response.success) {
            return {
                error: response.errorMessage,
            }
        }
  
        return response.result as unknown as CRUDResponse
    }
}

export default PageModel